export const DEFAULT_LAYOUT = 'layout_1';
export const DEFAULT_LOOPS = 3;
export const DEFAULT_DURATION = 3000;
export const DEFAULT_AUTO_SCROLL_ANIMATION_DURATION = 20000;
export const DEFAULT_MILLISECONDS_PER_PRODUCT = 1000;
export const DEFAULT_ON_LOAD_START_AUTO_SCROLL_AFTER = 5000;
export const DEFAULT_AUTO_SCROLL_NEXT_ANIMATION_DELAY = 3000;
export const DEFAULT_ON_INTERACTION_END_RESUME_AUTO_SCROLL_AFTER = 8000;

export class PromoGroup {
    constructor({
        id,
        name,
        layout,
        backgroundType,
        backgroundValue,
        topImage,
        bottomImage,
        titleColor,
        titleContent,
        subtitleColor,
        subtitleContent,
        closeButtonLabel,
        closeButtonBackgroundColor,
        closeButtonBorderColor,
        closeButtonLabelColor,
        loops,
        duration,
        autoScrollAnimationDuration,
        autoScrollNextAnimationDelay,
        onInteractionEndResumeAutoScrollAfter,
        onLoadStartAutoScrollAfter,
        products,
        createdAt,
        updatedAt
    }) {
        this.id = id;
        this.name = name;
        this.layout = layout;
        this.background = new Background({type: backgroundType, value: backgroundValue});
        this.topImage = topImage;
        this.bottomImage = bottomImage;
        this.title = new Title({color: titleColor, content: titleContent});
        this.subtitle = new Subtitle({color: subtitleColor, content: subtitleContent});
        this.closeButton = new CloseButton({
            label: closeButtonLabel,
            backgroundColor: closeButtonBackgroundColor,
            borderColor: closeButtonBorderColor,
            labelColor: closeButtonLabelColor
        });
        this.loops = loops || DEFAULT_LOOPS;
        this.duration = duration || DEFAULT_DURATION;
        this.autoScrollAnimationDuration = autoScrollAnimationDuration || DEFAULT_AUTO_SCROLL_ANIMATION_DURATION;
        this.autoScrollNextAnimationDelay = autoScrollNextAnimationDelay || DEFAULT_AUTO_SCROLL_NEXT_ANIMATION_DELAY;
        this.onInteractionEndResumeAutoScrollAfter = onInteractionEndResumeAutoScrollAfter || DEFAULT_ON_INTERACTION_END_RESUME_AUTO_SCROLL_AFTER;
        this.onLoadStartAutoScrollAfter = onLoadStartAutoScrollAfter || DEFAULT_ON_LOAD_START_AUTO_SCROLL_AFTER;
        this.products = products;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    };

    clone() {
        return new PromoGroup({
            id: this.id,
            name: this.name,
            layout: this.layout,
            backgroundType: this.background.type,
            backgroundValue: this.background.value,
            topImage: this.topImage,
            bottomImage: this.bottomImage,
            titleColor: this.title.color,
            titleContent: this.title.content,
            subtitleColor: this.subtitle.color,
            subtitleContent: this.subtitle.content,
            closeButtonLabel: this.closeButton.label,
            closeButtonBackgroundColor: this.closeButton.backgroundColor,
            closeButtonBorderColor: this.closeButton.borderColor,
            closeButtonLabelColor: this.closeButton.labelColor,
            loops: this.loops,
            duration: this.duration,
            autoScrollAnimationDuration: this.autoScrollAnimationDuration,
            autoScrollNextAnimationDelay: this.autoScrollNextAnimationDelay,
            onInteractionEndResumeAutoScrollAfter: this.onInteractionEndResumeAutoScrollAfter,
            onLoadStartAutoScrollAfter: this.onLoadStartAutoScrollAfter,
            products: this.products,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt
        });
    };
}

export const promoGroupConverter = {
    toFirestore() {
        return null;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        return new PromoGroup({
            id: snapshot.id,
            name: data.name,
            layout: data.layout,
            backgroundType: data.background.type,
            backgroundValue: data.background.value,
            topImage: data.top_image,
            bottomImage: data.bottom_image,
            titleColor: data.title.color,
            titleContent: data.title.content,
            subtitleColor: data.subtitle.color,
            subtitleContent: data.subtitle.content,
            closeButtonLabel: data.close_button.label,
            closeButtonBackgroundColor: data.close_button.background_color,
            closeButtonBorderColor: data.close_button.border_color,
            closeButtonLabelColor: data.close_button.label_color,
            loops: data.loops,
            duration: data.duration,
            autoScrollAnimationDuration: data.auto_scroll_animation_duration,
            autoScrollNextAnimationDelay: data.auto_scroll_next_animation_delay,
            onInteractionEndResumeAutoScrollAfter: data.on_interaction_end_resume_auto_scroll_after,
            onLoadStartAutoScrollAfter: data.on_load_start_auto_scroll_after,
            products: data.products,
            createdAt: data.created_at,
            updatedAt: data.updated_at
        });
    }
};

export class Background {
    constructor({type, value}) {
        this.type = type || 'css';
        this.value = value;
    };

    clone() {
        return new Background({type: this.type, value: this.value});
    };
};

export class Title {
    constructor({color, content}) {
        this.color = color || '#000000';
        this.content = content || '';
    };

    clone() {
        return new Title({color: this.color, content: this.content});
    };
};

export class Subtitle {
    constructor({color, content}) {
        this.color = color || '#000000';
        this.content = content || '';
    };

    clone() {
        return new Subtitle({color: this.color, content: this.content});
    };
};

export class CloseButton {
    constructor({label, backgroundColor, borderColor, labelColor}) {
        this.label = label || 'Close';
        this.backgroundColor = backgroundColor || '#ffffff';
        this.borderColor = borderColor || '#000000';
        this.labelColor = labelColor || '#000000';
    };

    clone() {
        return new CloseButton({
            label: this.label,
            backgroundColor: this.backgroundColor,
            borderColor: this.borderColor,
            labelColor: this.labelColor
        });
    };
}